<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
export default {
  name: 'Product'
}

</script>



// WEBPACK FOOTER //
// src/Osm/Product/containers/Product.vue